import type { ComponentChildren } from "preact";
import { DrawerNavContent } from "../drawer_nav/drawer_nav_content.tsx";
import { HeaderNav } from "../header_nav/header_nav.tsx";
import { DrawerNav } from "../drawer_nav/drawer_nav.tsx";
import { useMergedClassName } from "../utils.ts";

type MainLayoutProps = {
    children: ComponentChildren;
    title?: string;
    class?: string;
    fullScreen?: boolean;
};

export const MainLayout = (props: MainLayoutProps) => {
    const className = useMergedClassName("farpov_main_layout", props.class);
    const mainClass = useMergedClassName(
        "farpov_main_content",
        props.fullScreen ? "full-screen" : "container"
    );
    
    return (
        <div class={className}>
            {/* Desktop Sidebar - visible only on large screens */}
            <aside class="farpov_sidebar">
                <DrawerNavContent />
            </aside>

            {/* Main Content Area */}
            <div class="farpov_main_content_wrapper">
                <HeaderNav title={props.title} />
                <main class={mainClass}>
                    {props.children}
                </main>
            </div>

            {/* Mobile Drawer (Overlay) - logic handles visibility */}
            <DrawerNav />
        </div>
    );
};
